import React, { Component } from 'react';
import BlogPostItem from './BlogPostItem';

class BlogPost extends Component {
	constructor(props) {
		super(props);

		const blogPostData = {
			blogPostList: [
				{
					id: 1,
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					imgUrl: 'http://halasz.co.kr/FILE/HALASZ/1585701191334.jpg',
					heading: 'Nonetheless Spring, The Joy Of Travel Enjoying At Home [Weekend Leisure]',
					date: '1th April, 2020',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Spring is coming in the air all around the mountains and seas. Warm sunlight shines and the gentle breeze brings in the fragrance of flowers. In previous years this time around we would be ready to go to the mountains and the sea. However due to COVID19 people are reluctant to go out and enjoy the spring. Why don\'t you refrain from outdoor activities this spring and enjoy your trip at home using travel content prepared by tourism and venture companies? Introducing superior travel content for so-called "homebody"',
					post_contents:
						'Spring is coming in the air all around the mountains and seas. Warm sunlight shines and the gentle breeze brings in the fragrance of flowers. In previous years this time around we would be ready to go to the mountains and the sea. However due to COVID19 people are reluctant to go out and enjoy the spring. Why don\'t you refrain from outdoor activities this spring and enjoy your trip at home using travel content prepared by tourism and venture companies? Introducing superior travel content for so-called "homebody."\n' +
						'\n' +
						'\n' +
						'\n' +
						'■ Would you like to hook up a big fish online? HALASZ FISHING GRIP developed by ATOZSOFT CORP. is the first IoT based fishing grip. It can measure the length and the weight of the caught fish at once and also provide photo that are displayed not only the measurements but also fishing operating information such as date, location, weather, etc. by BLE. HALASZ FISHING GRIP is useful when fishing offline but HALASZ APP has an online fishing tournament content that are highly praised among anglers. Using the data and contents HALASZ APP provides, users can open various online fishing tournaments based on locations, countries, fish species, etc. and also participate as well.\n' +
						'\n' +
						'To participate these online fishing tournaments are simple. When participants upload the photo provided, the measurements, fishing operating information, fish species, etc. will be automatically listed and everybody can freely compete and communicate with anglers all over the world. HALASZ FISHING GRIP was also introduced and showed at CES2020 the world\'s biggest consumer technology show that was held at Las Vegas on January.'
				},
				{
					id: 2,
					imgUrl: 'http://halasz.co.kr/FILE/HALASZ/1581487851241.png',
					heading: 'HALASZ FISHING GRIP, Exhibits In CES2020 .',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '12th Feb, 2020',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'ATOZSOFT CORP.(CEO SUH HOJIN) has been nominated as an exhibitor for CES2020 which was held from Jan.7th for 4 days at Las Vegas. ATOZSOFT CORP. is recognized by the technology and idea for their new product, HALASZ FISHING GRIP.As it is the largest consumer electronics IT fair in the world, companies and people from various'
				},
				{
					id: 3,
					imgUrl: 'http://halasz.co.kr/FILE/HALASZ/1580890049558.png',
					heading: 'Length·Weight Measurable "HALASZ FISHING GRIP" Exhibits In CES2020',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '5th Feb, 2020',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'ATOZSOFT CORP.(CEO SUH HOJIN), recognized HALASZ FISHING GRIP\'s technology and idea, will be exhibiting at \'CES2020\' Eureka park zone, the world\'s biggest consumer electronic·IT show that is held in Las Vegas from Jan. 7th to Jan 10th.HALASZ FISHING GRIP applied length and weight sensor on a fishing grip that helps to pick up the caught'
				},
				{
					id: 4,
					imgUrl: 'http://halasz.co.kr/FILE/HALASZ/1577974345450.PNG',
					heading: '[MIK 2019 Season 1] Atozsoft Corp. Will Display IOT Fishing Grip, \'Harasz Fishing Grip,\' That Can Measure The Length And The Weight Of The Fish At Once',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '26th Dec, 2019',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Atozsoft Corp. will be participate 11th MIK (Made in Korea) 2019 Conference & Networking Season I, which will be held at El Tower Grand Volume in Yangjae-dong, July 18 (Thu).\'Harasz Fishing Grip\' is a product that applied weight and length sensor to a fishing grip, used to help pick up fish without being damaged by the teeth or thorns of'
				},
				{
					id: 5,
					imgUrl: 'http://halasz.co.kr/FILE/HALASZ/1577974804722.PNG',
					heading: 'The Importance of Onboarding Users to Your App',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '26th Dec, 2019',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Atozsoft Corp. participated in \'11th MIK (Made in Korea) 2019 Conference & Networking Season I\' held at El Bull Tower Grand Tower in Yangjae-dong, Yangju-dong on July 18 (Thursday) and introduced a fishing grip, \'Harasz Fishing Grip,\' that measures the weight and length of fish.\'Halasz Fishing Grip\' is a product that applied a sensor on a fishing'
				}
			]
		};

		this.state = blogPostData;
	}

	render() {
		const blogPostItems = this.state.blogPostList.map((item) => {
			return (
				<BlogPostItem
					key={item.id}
					imgUrl={item.imgUrl}
					heading={item.heading}
					thumbUrl={item.thumbUrl}
					writer={item.writer}
					date={item.date}
					post_type={item.post_type}
					post_cat={item.post_cat}
					post_comment={item.post_comment}
					post_info={item.post_info}
				/>
			);
		});

		return (
			<section className="post-area">
				{blogPostItems}
			</section>
		);
	}
}

export default BlogPost;
